export default "__VITE_ASSET__DuIR2YWM__"